import {defineAsyncComponent} from 'vue'
const StatsRouter = [
  
    // 关键词每日数据
    {
      path: 'stats_keyword',
      name: 'StatsKeyword',
      component: () => import('@/views/Stats/StatsKeyword/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 关键词累计数据
    {
      path: 'stats_keyword_sum',
      name: 'StatsKeywordSum',
      component: () => import('@/views/Stats/StatsKeywordSum/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 博主数据统计
    {
      path: 'stats_data_blogger',
      name: 'StatsBlogger',
      component: () => import('@/views/Stats/StatsBlogger/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    //团长每日统计
    {
      path: 'stats_data_director_daily',
      name: 'statsDirectorDaily',
      component: () => import('@/views/Stats/StatsDirectorDaily/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 团长累计数据
    {
      path: 'stats_data_director',
      name: 'statsDirector',
      component: () => import('@/views/Stats/StatsDirector/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 商务主管数据统计
    {
      path: 'stats_data_director_manager',
      name: 'statsDirectorManager',
      component: () => import('@/views/Stats/StatsDirectorManager/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 平台累计数据
    {
      path: 'stats_newer_platform',
      name: 'StatsPlatform',
      component: () => import('@/views/Stats/StatsPlatform/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    {
      path: 'stats_newer_platform_sum',
      name: 'StatsPlatformSum',
      component: () => import('@/views/Stats/StatsPlatformSum/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 核心指标看板
    {
      path: 'coreboard',
      name: 'CoreBoard',
      component: () => import('@/views/Stats/CoreBoard/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 数据上传
    {
      path: 'stats_data_upload',
      name: 'StatsDataUpload',
      component: () => import('@/views/Stats/StatsDataUpload/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 操作记录
    {
      path: 'operate_record',
      name: 'OperateRecord',
      component: () => import('@/views/Stats/OperateRecord/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    {
      path: 'activity',
      name: 'ActivityDatas',
      component: () => import('@/views/ActivityDatas/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
]
export {StatsRouter}
